import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import FormLayout from 'src/layouts/form';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const DashboardLayoutStore = lazy(() =>
  import('src/layouts/dashboard/layout').then((module) => ({ default: module.DashboardLayoutStore }))
);

const ProgramView = lazy(() => import('src/pages/programs/programView'));

const ProgramEditor = lazy(() => import('src/pages/programs/program-editor'));

const ProgramViewPDF = lazy(() => import('src/components/program/pdf/programViewPDF'));

const ProgramByParticipant = lazy(() => import('src/pages/programs/ProgramByParticipant'));


// ----------------------------------------------------------------------

export const ProgramOrganizationRoutes = [
  {
    path: 'programs',
    element: (
      <AuthGuard allowedRoles={['organization', 'manager']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <ProgramView />, index: true },
      { path: 'edition', element: <ProgramEditor /> },
      { path: 'participants', element: <ProgramByParticipant /> },
      { path: 'view', element: <ProgramViewPDF /> },
    ],
  },
];

export const ProgramParticipantRoutes = [
  {
    path: 'trainees/programs',
    element: (
      <AuthGuard allowedRoles={['trainee']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { path: 'view', element: <ProgramViewPDF /> },
    ],
  },
];
 